// extracted by mini-css-extract-plugin
export default {"advice":"widgets-contacts-and-settings-fields-ProfileAndSecurity-Security-Password-EditPasswordField__advice--5+pSH"};